<template>
  <div>
    <v-select
      v-if="
        filterData.type !== ('DATE') &&
        filterData.type !== ('SELECT') &&
        !filterData.is_association &&
        filterData?.string_input?.type !== 'date'
      "
      v-model="modelCondition"
      :items="filterData.conditions"
      item-text="text"
      item-value="value"
      outlined
      dense
      :label="$t('modules.customdata.filters.select_condition')"
      hide-details
      class="mb-2"
      return-object
      :menu-props="{
        contentClass: 'df__select',
      }"
    >
      <template v-slot:item="data">{{data.item.text}}</template>
    </v-select>

    <template v-if="filterData.is_association">
      <v-autocomplete
        outlined
        dense
        v-model="modelValue"
        :items="association_items"
        :item-text="(item) => item.label || item.name"
        item-value="id"
        :menu-props="{
          maxHeight: '400',
          contentClass: 'df__autocomplete',
        }"
        :placeholder="filterData.name"
        multiple
        persistent-hint
        hide-details
        return-object

        @focus="fetchAssociationItems(filterData)"
        :loading="association_items_loading ? 'white' : false"
        hide-no-data
      ></v-autocomplete>
    </template>

    <template
      v-else-if="getConditionValue(modelCondition) !== 'empty' && getConditionValue(modelCondition)"
    >
      <template v-if="filterData.type === 'FLOAT' || filterData.type === 'INTEGER' || filterData.type === 'BIGINT'">
        <template
          v-if="getConditionValue(modelCondition) === 'between' || getConditionValue(modelCondition) === 'notBetween'"
        >
          <v-text-field
            outlined
            dense
            class="custom-data__filters-number mb-2"
            v-model="arrayValues[0]"
            :label="$t('modules.customdata.filters.placeholder_from')"
            type="number"
            hide-details
          ></v-text-field>
          <v-text-field
            outlined
            dense
            class="custom-data__filters-number"
            v-model="arrayValues[1]"
            :label="$t('modules.customdata.filters.placeholder_to')"
            type="number"
            hide-details
          ></v-text-field>
        </template>
        <template v-else-if="isNumericFieldTextSearchCondition(getConditionValue(modelCondition))">
          <v-text-field
            outlined
            dense
            class="custom-data__filters-string"
            v-model="modelValue"
            :placeholder="returnFilterKeyOrLabel(filterData)"
            hide-details
          ></v-text-field>
        </template>
        <template v-else>
          <v-text-field
            outlined
            dense
            class="custom-data__filters-number"
            v-model="modelValue"
            :placeholder="returnFilterKeyOrLabel(filterData)"
            type="number"
            hide-details
          ></v-text-field>
        </template>

      </template>

      <template v-if="filterData.type === ('STRING') || filterData.type === 'TEXT'">
        <template v-if="getConditionValue(modelCondition) === 'multiple'">
          <v-autocomplete
            outlined
            dense
            v-model="modelValue"
            :items="filterData.values.values"
            :menu-props="{ maxHeight: '400' }"
            :label="returnFilterKeyOrLabel(filterData)"
            multiple
            hide-details
            persistent-hint
          ></v-autocomplete>
        </template>
        <template v-else-if="filterData?.string_input?.type === 'date'">
          <date-picker
            class="df-datepicker"
            v-model="modelValue"
            :lang="$i18n.locale"
            :append-to-body="true"
            :type="filterData.string_input.type"
            :valueType="filterData.string_input.format"
            :format="filterData.string_input.format"
            range
            :placeholder="$t('broadcasts.modal.schedule.choose_date_label')"
          />
        </template>
        <template v-else-if="filterData?.string_input?.type === 'time'">
          <v-text-field
            return-masked-value
            v-mask="filterData.string_input?.format?.replace(/[^:]/g, '#') || null"
            outlined
            dense
            class="custom-data__filters-string"
            v-model="modelValue"
            :placeholder="returnFilterKeyOrLabel(filterData)"
            hide-details
          ></v-text-field>
        </template>
        <template v-else>
          <v-text-field
            outlined
            dense
            class="custom-data__filters-string"
            v-model="modelValue"
            :placeholder="returnFilterKeyOrLabel(filterData)"
            hide-details
          ></v-text-field>
        </template>
      </template>

    </template>

    <template v-else-if="filterData.type === ('SELECT')">
      <v-autocomplete
        outlined
        dense
        v-model="modelValue"
        :items="filterData.values"
        :menu-props="{ maxHeight: '400' }"
        :label="returnFilterKeyOrLabel(filterData)"
        :item-text="item => item.name"
        :item-value="item => item.value"
        multiple
        hide-details
        persistent-hint
        return-object
      ></v-autocomplete>
    </template>

    <template v-else-if="filterData.type === ('DATE')">
      <v-menu
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            outlined
            dense
            hide-details
            v-model="modelValue"
            :placeholder="returnFilterKeyOrLabel(filterData)"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="modelValue"
          no-title
          :locale="i18n.locale"
          scrollable
          range
        >
        </v-date-picker>
      </v-menu>
    </template>
  </div>

</template>

<script>

import {mapActions, mapGetters} from "vuex";
import i18n from "@/lang/i18n";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/uk';
import 'vue2-datepicker/locale/ru';
import 'vue2-datepicker/locale/en';
import 'vue2-datepicker/locale/de';

export default  {
  name: 'DynamicFilter',

  components: {
    DatePicker,
  },

  props: {
    filterData: {
      type: Object,
      default: () => {},
    },
    selected_filters: {
      type: Object,
      default: () => {},
    },
    custom_linked_tables_values: {
      type: Object,
      default: () => {},
    },
    action_set_selected_filter_value: {
      type: String,
      default: '',
    },
    action_set_selected_filter_condition: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    i18n,
    itemModel: {
      value: null,
      condition: '',
    },
    arrayValues: [],

    association_items: [],
    association_items_loading: false,
  }),

  computed: {
    ...mapGetters([
      'get_custom_data_front_json',
    ]),

    modelValue: {
      get: function() {
        return this.selected_filters[this.filterData.name]?.value
      },
      set: function(value) {
        this.$store.dispatch(this.action_set_selected_filter_value, {
          key: this.filterData.name,
          value: value,
        })
      },
    },

    modelCondition: {
      get: function() {
        var allowedTypes = ['BOOLEAN', 'SELECT', 'DATE'];
        if (
          !this.selected_filters[this.filterData.name]?.condition
          && !allowedTypes.includes(this.selected_filters[this.filterData.name]?.type)
        ){

          //Set condition from json
          let condition_index = 0
          const config_condition = this.get_custom_data_front_json?.additional_filters_config?.default_condition_value
          if(
            config_condition
            && !this.filterData.hasOwnProperty('association')
          ) {

            const filter_condition_index = this.filterData.conditions.findIndex(item => item.value === config_condition)
            if (filter_condition_index >= 0) {
              condition_index = filter_condition_index
            }
          }
          //end Set condition from json

          this.$store.dispatch(this.action_set_selected_filter_condition, {
            key: this.filterData.name,
            condition: this.filterData.conditions[condition_index],
          })

          return this.filterData.conditions[condition_index]
        } else {
          return this.selected_filters[this.filterData.name]?.condition
        }
      },
      set: function(condition) {
        this.$store.dispatch(this.action_set_selected_filter_condition, {
          key: this.filterData.name,
          condition: condition,
        })
      },
    },
  },

  methods: {
    ...mapActions([
      'customDataSetSelectedFilterValue',
      'customDataSetSelectedFilterCondition',
    ]),

    getConditionValue(object) {
      return object?.value
    },

    isNumericFieldTextSearchCondition(value) {
      return ['like', 'notLike', 'startsWith', 'endsWith'].includes(value)
    },

    returnFilterKeyOrLabel(item) {
      return item?.label ? item?.label : item.name
    },

    async fetchAssociationItems(data){
      if(this.association_items?.length) return

      if(this.custom_linked_tables_values?.[data.name]?.length) {
        this.association_items = this.custom_linked_tables_values[data.name]
        return
      }

      this.association_items_loading = true

      await this.$store.dispatch('_customDataFetchGetLinkedTablesValues', {
        modelName: data.association.model_name,
        modelField: data.association?.model_field,
        linkedColumn: data?.name,
        bot_id: this.$route?.params?.id,
        fetch_filter: data?.fetch_filter,
        modelFieldLabel: data.association?.model_field_label,
        fetch_limit: data?.association?.fetch_limit,
        get_full_data: data?.association?.get_full_data,
        params: {
          for_filter: data?.name, //used in Action Jail
        }
      }).then(response => {
        this.association_items = response
      })

      this.association_items_loading = false
    },
  },

  watch: {
    arrayValues: function(afterVal) {
      this.modelValue = afterVal
    },

    //comments because on changing savedFilters cleared Values
    modelCondition: function(val) {
      if (val?.value === 'empty') {
        this.modelValue = 'empty'
      } else if (val?.value === 'active') {
        this.modelValue = 'active'
      }else if (val?.value === 'notActive') {
        this.modelValue = 'notActive'
      }
      // } else if (val?.value === 'between' || val?.value === 'notBetween') {
      //   this.arrayValues = []
      // } else {
      //   this.modelValue = null
      // }
    },
  },

}
</script>

<style scoped lang="scss">
.v-application--is-ltr .v-list-item__action:first-child {
    margin-right: 16px !important;
}

.df-datepicker{
  &.mx-datepicker {
    width: 100% !important;

    .mx-input{
      border-color: red !important;
    }
  }
}
</style>

<style lang="scss">
.df__autocomplete {
  .v-list-item__action {
    margin: 8px 8px 8px 0 !important;
  }
  .v-list-item__content {
    .v-list-item__title {
      font-size: 12px;
    }
  }
}

.df__select {
  .v-list-item {
    font-size: 14px;
  }
}
</style>
